import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Tag from "./tags/Tag";
import Category from "./categories/Category";
import Merchant from "./merchants/Merchant";
import Account from "./accounts/Account";
import Transactions from "./transactions/Transactions";
import Investments from "./investment/Investments"
import {apiFetch} from "../api"
import Recurring from "../recurring/Recurring";
import Stocks from "./stocks/Stocks";
import SpendingInsights from "./insights/SpendingInsights";
import {BASE_URL as u} from "../../commonUrls";
import "./ExpenseTracker.css";

const BASE_URL = `${u}/account`;

export default function ExpenseTracker() {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    try {
      const response = await apiFetch(
        `${BASE_URL}`
      );

      if (!response.ok) {
        const err = await response.json();
        setError(err.message || "Unauthorized");
        return;
      }

      const data = await response.json();
      setBalance(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="expense-tracker-loading">Loading balance...</p>;
  

  return (
    <Routes>

      {/* DEFAULT /expense */}
      <Route 
        index
        element={
          <div className="expense-tracker-dashboard">

            {/* BALANCE */}
          <div className="expense-tracker-balance-wrap">
            <div className="expense-tracker-balance-label">Total Balance</div>
            <div className="expense-tracker-balance-value">
              ₹ {balance ?? 0}
            </div>
          </div>

          {/* NON-BLOCKING ERROR MESSAGE */}
          {error && (
            <div className="expense-tracker-error">
              No account found yet. Create your first account to start tracking finances.
            </div>
          )}


            {/* BUTTONS */}
            <div className="expense-tracker-actions">
              <ActionButton label="Accounts" onClick={() => navigate("accounts")} />
              <ActionButton label="Transactions" onClick={() => navigate("transactions")} />
              <ActionButton label="Investments" onClick={() => navigate("investments")} />
              <ActionButton label="Recurring" onClick={()=> navigate("recurring")} />
              <ActionButton label="Stocks" onClick={() => navigate("stocks")} />
              <ActionButton label="Categories" onClick={() => navigate("categories")} />
              <ActionButton label="Tags" onClick={() => navigate("tags")} />
              <ActionButton label="Merchants" onClick={() => navigate("merchants")} />
              <ActionButton label="Insights" onClick={() => navigate("insights")} />
            </div>
          </div>
        }
      />
      {/* <Route index element={ DASHBOARD } /> */}

      {/* SUB ROUTES */}
      <Route path="tags/*" element={<Tag />} />
      <Route path="categories/*" element={<Category />} />
      <Route path="merchants/*" element={<Merchant />} />
      <Route path="accounts/*" element={<Account />} />
      <Route path="transactions/*" element={<Transactions />} />
      <Route path="investments/*" element={<Investments />} />
      <Route path="recurring/*" element={<Recurring/>} />
      <Route path="stocks/*" element={<Stocks />} />
      <Route path="insights" element={<SpendingInsights />} />
    </Routes>
  );
}

function ActionButton({ label, onClick }) {
  return (
    <button
      className="expense-tracker-action-btn"
      onClick={onClick}
    >
      {label}
    </button>
  );
}
